import { render, staticRenderFns } from "./screening-radio-button.vue?vue&type=template&id=46a6f767&scoped=true"
import script from "./screening-radio-button.vue?vue&type=script&lang=js"
export * from "./screening-radio-button.vue?vue&type=script&lang=js"
import style0 from "./screening-radio-button.vue?vue&type=style&index=0&id=46a6f767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a6f767",
  null
  
)

export default component.exports